import { render, staticRenderFns } from "./CourseLessonItem.vue?vue&type=template&id=58f569a4&"
import script from "./CourseLessonItem.vue?vue&type=script&lang=ts&"
export * from "./CourseLessonItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports